module.exports = __webpack_public_path__ + "img/dd39cd1.jpg";